import { Box, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useScreenSize from 'hooks/useScreenSize';

const ContentFrame = ({ children, innerRef }) => {
    const theme = useTheme();
    const matchDownSm = useMediaQuery(theme.breakpoints.down('md'), { noSsr: false, defaultMatches: false });
    const matchDown1280 = useMediaQuery((theme) => theme.breakpoints.down(1280), { noSsr: false, defaultMatches: false });
    const screenSize = useScreenSize();

    return (
        <Box
            ref={innerRef}
            sx={(t) => ({
                display: 'flex',
                justifyContent: 'center',
                bgcolor: '#FFFFFF',
                margin: '0 !important',
                borderTopLeftRadius: '80px',
                borderTopRightRadius: '80px',
                [t.breakpoints.down('md')]: {
                    borderTopLeftRadius: '40px',
                    borderTopRightRadius: '40px'
                }
            })}
        >
            <Grid
                container
                spacing={2}
                sx={(t) => ({
                    minHeight: '100vh',
                    display: 'flex',
                    flexFlow: 'column',
                    justifyContent: 'center',
                    width: '100% !important',
                    maxWidth: '1280px',
                    margin: `0 ${(screenSize.width - 1280 - 15) / 2}px !important`,
                    padding: '120px 40px !important',
                    [t.breakpoints.down('md')]: {
                        padding: '80px 20px !important',
                        margin: '0 auto !important'
                    }
                })}
            >
                {children}
            </Grid>
        </Box>
    );
};

export default ContentFrame;
